import { render, staticRenderFns } from "./ArtView.vue?vue&type=template&id=0faf5820&scoped=true"
import script from "./ArtView.vue?vue&type=script&lang=js"
export * from "./ArtView.vue?vue&type=script&lang=js"
import style0 from "./ArtView.vue?vue&type=style&index=0&id=0faf5820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faf5820",
  null
  
)

export default component.exports